import { takeEvery } from 'redux-saga'
import { put, select, call, all } from 'redux-saga/effects'
import { CHANGE_CAMERA_MODEL, setCameraModelAction, updateCameraAction } from 'actions/cameraActions'
import { changeCameraModelSelector } from 'selectors'
import { setMultiImagerAction, clearMultiImagerLensesAction } from 'actions/multiImagerActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import findById from 'helpers/findById'

const shouldUpdateModel = (currentCamera, lensId, cameras) => {
  return lensId !== currentCamera.id && currentCamera.isPtzImager === findById({ state: cameras, id: lensId }).isPtzImager
}

export function * changeCameraModel(action) {
  try {
    const { currentCamera, cameras } = yield select(changeCameraModelSelector)
    const { id, isMultiImager, lensIds, imagerId, remove } = currentCamera
    const { model, aov } = action
    const nextIsMultiImager = (model.form_factor || '').toLowerCase() === 'multi-imager'
    const isSameModel = currentCamera.model && currentCamera.model.id === model.id

    // delete lenses before updating model
    if (isMultiImager && !isSameModel) {
      // remove multi imager and lenses from map
      if (!nextIsMultiImager) {
        yield call(remove)
        yield all(lensIds.map(lensId => call(findById({ state: cameras, id: lensId }).remove)))
      }
      yield put.resolve(clearMultiImagerLensesAction(id, lensIds))
    }

    if (nextIsMultiImager) {
      isSameModel ? yield put(setCameraModelAction(model, aov)) : yield put(setMultiImagerAction(model, aov, isMultiImager))
    } else {
      // update all other lenses before updating model
      if (imagerId && !action.applySingle) {
        const multiImager = cameras.find(c => c.id === imagerId)
        yield all(multiImager.lensIds.map(lensId => shouldUpdateModel(currentCamera, lensId, cameras) && put(updateCameraAction('model', { model, aov }, lensId))))
      }

      yield put(setCameraModelAction(model, aov))
    }
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for change camera model action, then call function */
export function * watchChangeCameraModel() {
  yield * takeEvery(CHANGE_CAMERA_MODEL, changeCameraModel)
}



// WEBPACK FOOTER //
// ./src/sagas/changeCameraModelSaga.js